import { MACRO_KEY } from "../../../defaults";
import { OverviewTemplates as CardsTemplates } from "../../drawers/templates/features/cards/CardsTemplates";
import { OverviewTemplates as PanelsTemplates } from "../../drawers/templates/features/panels/PanelsTemplates";
import { OverviewTemplates as ButtonTemplates } from "../../drawers/templates/features/button/ButtonTemplates";
import { OverviewTemplates as AnnouncementTemplates } from "../../drawers/templates/features/announcements/AnnouncementsTemplates";
import { OverviewTemplates as CountdownTemplates } from "../../drawers/templates/features/countdown/CountdownTemplates";
import { OverviewTemplates as ImageSliderTemplates } from "../../drawers/templates/features/image-slider/ImageSliderTemplates";
import { OverviewTemplates as NewsTemplates } from "../../drawers/templates/features/news/NewsTemplates";
import { OverviewTemplates as PagesTemplates } from "../../drawers/templates/features/pages/PagesTemplates";
import { OverviewTemplates as SpacesTemplates } from "../../drawers/templates/features/spaces/SpacesTemplates";
import { OverviewTemplates as PeopleTemplates } from "../../drawers/templates/features/people/PeopleTemplates";
import { OverviewTemplates as UpcomingBirthdayTemplates } from "../../drawers/templates/features/upcoming-birthdays/UpcomingBirthdayTemplates";
import { OverviewTemplates as RecentlyActiveTemplates } from "../../drawers/templates/features/recently-active/RecentlyActiveTemplates";
import { OverviewTemplates as NewStartersTemplates } from "../../drawers/templates/features/new-starters/NewStartersTemplates";

export const OVERVIEW_CATEGORIES = {
  ALL: "all",
  PAGE_BUILDER: "pageBuilder",
  CONFLUENCE_CONTENT: "confluenceContent",
  TEAMS_AND_ACTIVITY: "teamsAndActivity",
};

export const OVERVIEW_TABS = (t) => {
  return [
  { label: t("all"), id: OVERVIEW_CATEGORIES.ALL },
  { label: t("overview-tabs.page-builder"), id: OVERVIEW_CATEGORIES.PAGE_BUILDER },
  { label: t("overview-tabs.confluence-content"), id: OVERVIEW_CATEGORIES.CONFLUENCE_CONTENT },
  { label: t("overview-tabs.teams-and-activity"), id: OVERVIEW_CATEGORIES.TEAMS_AND_ACTIVITY },
]};

export const OVERVIEW_TEMPLATES = [
  {
    macro: MACRO_KEY.CARDS,
    title: "cards",
    link: "view-all-cards",
    Component: CardsTemplates,
    category: OVERVIEW_CATEGORIES.PAGE_BUILDER,
  },
  {
    macro: MACRO_KEY.PANEL_SIMPLE,
    title: "panels",
    link: "view-all-panels",
    Component: PanelsTemplates,
    category: OVERVIEW_CATEGORIES.PAGE_BUILDER,
  },
  {
    macro: MACRO_KEY.BUTTON_INLINE,
    title: "buttons",
    link: "view-all-buttons",
    Component: ButtonTemplates,
    category: OVERVIEW_CATEGORIES.PAGE_BUILDER,
  },
  {
    macro: MACRO_KEY.ANNOUNCEMENTS,
    title: "announcements",
    link: "view-all-announcements",
    Component: AnnouncementTemplates,
    category: OVERVIEW_CATEGORIES.PAGE_BUILDER,
  },
  {
    macro: MACRO_KEY.COUNTDOWN,
    title: "countdowns",
    link: "view-all-countdowns",
    Component: CountdownTemplates,
    category: OVERVIEW_CATEGORIES.PAGE_BUILDER,
  },
  {
    macro: MACRO_KEY.IMAGE_SLIDER,
    title: "image-sliders",
    link: "view-all-image-sliders",
    Component: ImageSliderTemplates,
    category: OVERVIEW_CATEGORIES.PAGE_BUILDER,
  },
  {
    macro: MACRO_KEY.NEWS,
    title: "news",
    link: "view-all-news",
    Component: NewsTemplates,
    category: OVERVIEW_CATEGORIES.CONFLUENCE_CONTENT,
  },
  {
    macro: MACRO_KEY.PAGES,
    title: "pages",
    link: "view-all-pages",
    Component: PagesTemplates,
    category: OVERVIEW_CATEGORIES.CONFLUENCE_CONTENT,
  },
  {
    macro: MACRO_KEY.SPACES,
    title: "spaces",
    link: "view-all-spaces",
    Component: SpacesTemplates,
    category: OVERVIEW_CATEGORIES.CONFLUENCE_CONTENT,
  },
  {
    macro: MACRO_KEY.PEOPLE,
    title: "people",
    Component: PeopleTemplates,
    category: OVERVIEW_CATEGORIES.TEAMS_AND_ACTIVITY,
  },
  {
    macro: MACRO_KEY.UPCOMING_BIRTHDAYS,
    title: "upcoming-birthdays",
    Component: UpcomingBirthdayTemplates,
    category: OVERVIEW_CATEGORIES.TEAMS_AND_ACTIVITY,
  },
  {
    macro: MACRO_KEY.RECENTLY_ACTIVE,
    title: "recently-active",
    Component: RecentlyActiveTemplates,
    category: OVERVIEW_CATEGORIES.TEAMS_AND_ACTIVITY,
  },
  {
    macro: MACRO_KEY.NEW_STARTERS,
    title: "new-starters",
    Component: NewStartersTemplates,
    category: OVERVIEW_CATEGORIES.TEAMS_AND_ACTIVITY,
  },
];
